import { render, staticRenderFns } from "./Report-form.vue?vue&type=template&id=888e8d4e&"
import script from "./Report-form.vue?vue&type=script&lang=js&"
export * from "./Report-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports